import request from '@/util/request'

/** 获取服务数据 */
export function getServiceData() {
    return request({
        url: '/company/serviceData',
        method: 'get'
    })
}

/** 获取公司简介 */
export function getIntroduction() {
    return request({
        url: '/company/introduction',
        method: 'get'
    })
}

/** 获取联系我们 */
export function getContactUs() {
    return request({
        url: '/company/contactUs',
        method: 'get'
    })
}

/** 获取诚聘英才 */
export function getJob() {
    return request({
        url: '/company/job',
        method: 'get'
    })
}